// Fase 5.14 (05-remediation.md) — `ApiError` vivía en `shared/api/apiClient.js`, así que
// cualquier componente presentacional que solo la necesita para un `err instanceof ApiError`
// (distinguir "el servidor respondió 4xx/5xx" de "falló la red") tenía que importar de
// `shared/api/*` y cruzaba la regla de frontera. Es un tipo de error compartido, no un cliente
// de fetch — su lugar es `shared/errors/`. `apiClient.js` la re-exporta para no romper imports.
export class ApiError extends Error {
    constructor(message, status, body) {
        super(message);
        this.status = status;
        this.body = body;
    }
}
